<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Prologue</h1>
</div>
</div>
<p class="first">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">The wails of the first child still echoed through the villa as a second cry rang out announcing the arrival of another babe.</span></p>
<p class="indent">
	Leaving his flame-haired wife sleeping with his pale daughter at her breast, the Emperor Claudius rushed to the next chamber to the new sound of life.</p>
<p class="indent">
	As he entered the darkened room his eyes met those of Sophia—those great, black eyes that seemed to hold the mysteries of the ages within their depths.</p>
<p class="indent">
	Reaching out a trembling hand to him, Sophia spoke in a whisper. “I give you my daughter, Caesar.”</p>
<p class="indent">
	And then her eyes closed—forever.</p>
<p class="indent">
	Claudius knelt beside the bed and covered her still hand with kisses and tears. Why? Why? She was only a child herself. Had his need for her cost her life?</p>
<p class="indent">
	As the infant with hair as black as night was taken from its mother, Claudius stayed alone to grieve—to remember.</p>
<p class="sectiontop">
	Sophia, young as she was, could not have gone without notice. Though always obedient to her mistress, the Empress Messalina, Sophia exuded an aura of passion. More than once Claudius had felt heat rise in his body for no apparent reason, only to turn and find Sophia’s almond eyes on him, shifting the instant he caught her staring.</p>
<p class="indent">
	He had fought his need for her. After all, she was so young, so innocent—and a slave. He had told himself with much conviction that such an alliance would be beneath the emperor. But there came a night when he found that even the emperor was no more than a man.</p>
<p class="indent">
	Restless and craving a glass of wine, Claudius had crept from the great bed where his new wife lay sleeping, her hair fanned about her beautiful face upon the satin pillow. He longed to wake her. He wanted more than wine. But he stayed his passions.</p>
<p class="indent">
	When he reached the triclinium of the villa, he poured a goblet of Falernian, then turned as he heard splashing from the pool. Going quietly to the terrace, Claudius looked out and could not draw his eyes away.</p>
<p class="indent">
	Gowned only in moonlight, Sophia’s curved and sculpted body glowed with what seemed an inner light. She swam gracefully to one end of the pool and then floated almost motionless as the moon reflected in her wide eyes.</p>
<p class="indent">
	Diving deep, she disappeared. His heart stopped for an instant until she broke the surface with a shower of gleaming droplets flying heavenward. Slowly, she moved through the water like some enchanted creature of the sea. When she climbed the golden steps to end her night frolic, Claudius was there to press a warm robe about her shoulders.</p>
<p class="indent">
	She showed no surprise as she turned to him and spoke in her low and sultry Eastern voice, “Thank you, Caesar. The night air is chilly.”</p>
<p class="indent">
	He remembered the feel of her damp, cool cheek as he brushed it with his lips and asked, “Then why, Sophia, do you choose to swim at night?”</p>
<p class="indent">
	Her eyes met his as she answered, “I am Greek. Long before my family was forced into servitude my ancestors lived on the isle of Crete. There everyone swims by day or night—from the newborn babies to the aged and infirm who must be carried to the shore. The salts of the water cure the body and cleanse the mind.”</p>
<p class="indent">
	Slipping the robe from her shoulders, Claudius observed, “Such a body needs no cure.”</p>
<p class="indent">
	“But I must cleanse my mind of thoughts I shouldn’t have—needs which go unfulfilled.”</p>
<p class="indent">
	As his arms closed about her, he could feel her shivering, and her flesh felt cool against his bare chest. Claudius lifted her light form in his arms and carried her without a word to her chamber. Though she was a slave, her room was in the main part of the villa, since she served the empress.</p>
<p class="indent">
	Laying her gently on her bed, the emperor turned up the lamp to gaze on his prize. Sophia did not move to cover herself, but lay before him breathing deeply so that her breasts rose and fell in a seductive rhythm. Her eyes remained calm and fastened on his face. She did not fear him.</p>
<p class="indent">
	After minutes of devouring her with his eyes, Claudius tasted her lips. She clung to him with an expertise seldom known in one so young. Her body aroused and invited him. But dared he, the emperor?</p>
<p class="indent">
	Then they met—flesh to flesh—and they melted together in love. He was no longer the emperor, but the man, Claudius. She was no longer the slave girl, but the woman, Sophia. He knew that their love could not be denied.</p>
<p class="indent">
	As he entered her, Sophia let out a slight cry. Claudius halted as he realized he was the first man she had known. But she urged him on—deeper and deeper. He felt himself diving as she had dived beneath the cool waters of the salt pool.</p>
<p class="indent">
	At last a white light burst in his brain—the light of Apollo blinding him in his ecstasy, carrying him toward the heavens.</p>
<p class="indent">
	Afterward, as they lay in each other’s arms, Claudius caressed her soft skin as he asked, “Why didn’t you tell me, Sophia?”</p>
<p class="indent">
	Her lips touched his ear. “Tell you what, my Caesar?”</p>
<p class="indent">
	“That you had never before known love?”</p>
<p class="indent">
	She regarded him solemnly. “I have waited for you. I always knew there would be a man I would love and he would love me back. When I first saw you, I knew.”</p>
<p class="indent">
	The world dissolved once more as Claudius reached the heights, carrying with him his love. Sophia. Never before had he known such emotions. Surely, the gods meant it to be so.</p>
<p class="indent">
	He stayed with her until the dawn’s first light crept into the chamber to gild her olive skin. After that night, Sophia had never had to swim alone again. He had called her his “exotic flower of the dark hours,” his “night-blooming Ceres.”</p>
<p class="sectiontop">
	As her flesh cooled in his hand, Claudius bent forward to taste her lips one last time. His tears fell on her face, where he had never seen tears. She had been happy for the months they had together. In this, if nothing else, he took consolation.</p>
<p class="indent">
	Her words came back to him as an echo in the quiet room. “I give you my daughter, Caesar.”</p>
<p class="indent">
	He spoke to Sophia even as the bloom of her soft cheeks began to fade. “I accept your gift, my dearest. She shall be called Claudia Acte, and, like her mother, she shall know no man until she knows love. May the gods grant her half as sweet a love as I have known.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_xxxxxxxxxxxxx_Fm003.vue?14b23164